import { render, staticRenderFns } from "./ConfigRule.vue?vue&type=template&id=6a207bbd&scoped=true&"
import script from "./ConfigRule.vue?vue&type=script&lang=js&"
export * from "./ConfigRule.vue?vue&type=script&lang=js&"
import style0 from "./ConfigRule.vue?vue&type=style&index=0&id=6a207bbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a207bbd",
  null
  
)

export default component.exports